import { render, staticRenderFns } from "./kf.vue?vue&type=template&id=d5db854a&scoped=true"
import script from "./kf.vue?vue&type=script&lang=js"
export * from "./kf.vue?vue&type=script&lang=js"
import style0 from "./kf.vue?vue&type=style&index=0&id=d5db854a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5db854a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/publish/iot-cloud-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d5db854a')) {
      api.createRecord('d5db854a', component.options)
    } else {
      api.reload('d5db854a', component.options)
    }
    module.hot.accept("./kf.vue?vue&type=template&id=d5db854a&scoped=true", function () {
      api.rerender('d5db854a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/baseInfo/kf.vue"
export default component.exports